module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "达标等级",
      "is-link": ""
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "七彩星级",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.toNext('ClubIndex')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "技术等级",
      "is-link": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f77729be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubDetailKaoji.vue
// module id = 1571
// module chunks = 0